intra_module.factory('Achievement', function($resource, $location, achievements_url) {
    const url     = `${achievements_url}/api/users/:login/achievements/`;
    const params  =
        {login: '@login'};
    const actions = {
        query: {
            method:          'GET',
            isArray:         true,
            withCredentials: true,
            transformResponse(data, headers) {
				try {
					const achievements = angular.fromJson(data);
					if (achievements !== null && typeof achievements !== 'string' && achievements.length !== undefined) {
						for (let achievement of achievements) {
							achievement.image = `${achievements_url}${achievement.image}`;
						}
						return achievements;
					}
					return [];
				} catch (exception) {
					return [];
				}
            }
        }
    };

    return $resource(url, params, actions);
});
